const NOTIFICATION_STRINGS = {
  APPLICATION_SAVED: 'Application saved.',
  APPLICATION_DELETED: 'Application deleted.',
  APPLICATION_UPDATED: 'Changes saved.',
  DUPLICATE_BUTTON: 'Duplicate',
  PRINT_PDF_BUTTON: 'Print PDF',
  ERROR_TITLE: 'Unable to save Application.',
  ERROR_MESSAGE:
    'An error prevented your Application from being saved. Please try again.',

  CONTACT_BUTTON: 'Contact Support',
  DOWNLOADING_PDF_MESSAGE: 'Loading PDF...',
  // PDF export error messages
  PDF_ERROR_TITLE: 'Unable to create PDF.',
  PDF_ERROR_MESSAGE:
    'An error prevented your PDF from being created. Please try again.',
  PDF_TRY_AGAIN_BUTTON: 'Try Again',
  // Delete operation messages
  DELETING_APPLICATION_MESSAGE: 'Deleting Application...',
  DELETE_CONFIRM_TITLE: 'Delete Application?',
  DELETE_ERROR_TITLE: 'Unable to delete Application.',
  DELETE_ERROR_MESSAGE:
    'An error prevented your Application from being deleted. Please try again.'
};

export default NOTIFICATION_STRINGS;
